<div class="reports-page">
  <ysh-table-set [dataSource]="dataSource"></ysh-table-set>
</div>
